'use strict';

export default class Footer {
  constructor(options) {
    console.log('Footer module');

    const defaults = {
    	sitesSwitchElem: '.footer__select'
    };

    this.options = Object.assign({}, defaults, options);

    //exposed methods

    this.listemSiteSwitch = this._listemSiteSwitch;
  }

  _listemSiteSwitch () {

    $(this.options.sitesSwitchElem).on('change', function (evt) {
      let selected = $(this).find(":selected").val();

      if(selected !== '')
        window.open(selected, '_blank');
    });

  	return this;
  }
}
